import { AxiosGlobal } from "../shared/axios";
import { AxiosPromise } from "axios";
import configs from "../../configs";
import { store } from "../../store/store";

export class SuperAdminLiveApi extends AxiosGlobal {

  getlinksCount(): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-admin-stats`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllUsers(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-customers?page=${pageNo}&search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllShipments(pageNo: any, query: any, viewType: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-shipment?page=${pageNo}&search=${query}&view_type=${viewType}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }



  getReimbursements(query: any): AxiosPromise<any> {
    const params = new URLSearchParams(query).toString();
    return this.axios.get(`${configs.context}/admin/reimbursements?${params}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  createReimbursement(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/reimbursements`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  approveReimbursementL1(id: number, data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/reimbursements/${id}/approve-l1`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  approveReimbursementL2(id: number, data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/reimbursements/${id}/approve-l2`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  rejectReimbursement(id: number, data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/reimbursements/${id}/reject`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getReimbursementFleetDropdown(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/reimbursements/fleet-dropdown`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }


  /**
 * Upload a batch of pre-parsed shipment rows (sent from frontend after parsing Excel).
 * The frontend slices the file into batches of 50 rows and calls this endpoint per batch.
 */
  /**
   * One batch of shipment number -> docket number pairs.
   *
   * The sheet is parsed in the browser and posted in chunks, exactly like the shipment
   * import. A single request carrying the whole sheet (64,918 rows) killed the worker —
   * the browser reported the dead worker as a CORS error.
   *
   * `commit: false` reports what would change and writes nothing.
   */
  updateDocketNumbers(pairs: { number: string; docket: string; date?: string; account_code?: string }[], commit: boolean): AxiosPromise<any> {
    return this.axios.post(
      `${configs.context}/shipment/update-docket-numbers`,
      { pairs, commit },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        },
        timeout: 120000,
      }
    );
  }

  uploadImportExcelBatch(data: {
    header: string[];
    rows: any[][];
    batch_number: number;
    total_batches: number;
  }): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/shipment/upload-shipment-excel-batch`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      timeout: 120000, // 2 min per batch — plenty for 50 rows
    });
  }

  getFleetManifestShipments(query: any): AxiosPromise<any> {
    const params = new URLSearchParams(query).toString();
    return this.axios.get(`${configs.context}/admin/analytics/fleet-manifest-shipments?${params}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }


  getShipmentManifestInfo(shipmentNumbers: string[]): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/shipment/manifest-info`, { shipment_numbers: shipmentNumbers }, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }


  getNigerianStates(): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/nigerian-cities/states`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getNigerianCities(state: string): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/nigerian-cities?state=${encodeURIComponent(state)}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getRiderMetroCities(riderProfileId: number): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/rider/${riderProfileId}/metro-cities`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  syncRiderMetroCities(riderProfileId: number, data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/admin/rider/${riderProfileId}/metro-cities`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllShipmentsForExport(query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-shipments-for-export?date_from=${query?.date_from}&date_to=${query?.date_to}&destination_state=${query?.destination_state}&shipment_status=${query?.shipment_status}&email=${query?.email}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  /**
   * Monthly shipment report. The file is STREAMED by the server, so it is taken
   * as a blob rather than parsed — the old export returned every row as JSON and
   * could not survive a month's worth of shipments.
   */
  shipmentReportPreview(query: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/shipment-report/preview`, query, {
      headers: { "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}` },
    });
  }

  shipmentReportExport(query: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/shipment-report/export`, query, {
      headers: { "Accept": "text/csv", "Authorization": `Bearer ${store.getState().data.login.value.token}` },
      responseType: 'blob',
      // A month of shipments takes longer than the default; the server streams
      // from the first row, but the whole download still has to finish.
      timeout: 600000,
    });
  }

  getSingleUserShipment(id: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-single-user-shipment/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateShipmentData(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/shipment/update-shipment/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateRider(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/update-rider/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateFleet(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/update-fleet/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteRider(data: any): AxiosPromise<Array<any>> {
    return this.axios.delete(`${configs.context}/admin/delete-rider/${data}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteFleet(data: any): AxiosPromise<Array<any>> {
    return this.axios.delete(`${configs.context}/admin/delete-fleet/${data}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateShipmentStatus(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/shipment/update-shipment-status/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateShipmentStatusForDelivery(data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/shipment/update-shipment-status-for-pof`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateMultipleShipmentStatus(data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/shipment/update-multiple-shipment-status`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  /**
 * Get shipments for batch update - returns shipment numbers and recommended batch size
 */
  getManifestShipmentsForBatchUpdate(manifestId: number): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/manifest/${manifestId}/shipments-for-batch`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /**
   * Update manifest metadata only (first step of batch update process)
   * Returns shipment_numbers array for frontend batching
   */
  updateManifestMetadata(manifestId: number, data: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/manifest/${manifestId}/metadata`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /**
   * Process a batch of shipments for manifest status update
   * Called multiple times by frontend for each batch of shipments
   */
  batchUpdateManifestShipments(data: {
    manifest_id: any;
    shipment_numbers: string[];
    new_status: string;
    status_id: any;
    batch_number: number;
    total_batches: number;
    event_datetime: string;
  }): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/manifest/batch-update-shipments`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  updateShipmentOffice(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/shipment/update-shipment-office/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateShipmentRider(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/shipment/update-shipment-rider/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteShipment(data: any): AxiosPromise<Array<any>> {
    return this.axios.delete(`${configs.context}/admin/delete-shipment/${data}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllInvoices(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-invoices?page=${pageNo}&search=${query?.search}&from=${query?.from}&to=${query?.to}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  /**
 * Validate shipment numbers for barcode scanner
 */
  validateShipmentNumbers(shipmentNumbers: string[]): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/shipment/validate-shipment-numbers`, {
      shipment_numbers: shipmentNumbers
    }, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /**
   * Get shipment statistics for dashboard
   */
  getShipmentStats(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/shipment-stats`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /**
   * Prepare shipments for mass update with validation
   */
  prepareMassUpdate(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/shipment/prepare-mass-update`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getAllExpense(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-expenses?page=${pageNo}&search=${query?.search}&from=${query?.from}&to=${query?.to}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  exportAllExpenses(query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/export-all-expenses?search=${query?.search}&from=${query?.from}&to=${query?.to}&limit=${query?.limit || 50000}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  sendInvoice(data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/admin/send-invoice`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getCustomersForDropdown(type: string, search: string = ''): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/customers-dropdown?type=${type}&search=${encodeURIComponent(search)}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  previewInvoice(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/invoice-preview`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  // ── Expense voucher approval workflow ──────────────────────
  getVoucherLevels(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/voucher-workflow/levels`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getVoucherApproverCandidates(search: string = ''): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/voucher-workflow/approver-candidates?search=${encodeURIComponent(search)}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  createVoucherLevel(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/voucher-workflow/levels`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateVoucherLevel(id: number, data: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/voucher-workflow/levels/${id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  reorderVoucherLevels(levelIds: number[]): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/voucher-workflow/levels/reorder`, { level_ids: levelIds }, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteVoucherLevel(id: number): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/voucher-workflow/levels/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getVoucherTimeline(voucherId: number): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/voucher-workflow/vouchers/${voucherId}/timeline`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  approveVoucherStep(voucherId: number, data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/voucher-workflow/vouchers/${voucherId}/approve`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  rejectVoucherStep(voucherId: number, data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/voucher-workflow/vouchers/${voucherId}/reject`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  resubmitVoucher(voucherId: number, data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/voucher-workflow/vouchers/${voucherId}/resubmit`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  bulkMarkInvoicesPaid(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/invoices/bulk-mark-paid`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  // Returns the same PDF that is attached to the customer's invoice email.
  downloadInvoicePdf(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/invoice-download`, data, {
      responseType: 'blob',
      headers: { "Content-Type": "application/json", "Accept": "application/pdf", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllRiders(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-riders?page=${pageNo}&search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllFleetsForDropdown(): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-fleets-dropdown`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllRidersByFleet(id: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-riders-by-id/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllFleet(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-fleet?page=${pageNo}&search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllFleetWithoutPagination(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-fleet-without-pagination?page=${pageNo}&search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }




  getAllStaffs(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-staffs?page=${pageNo}&search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllGms(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-gms?page=${pageNo}&search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  //Branch
  getAllBranch(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-branch?page=${pageNo}&search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getTotalBranch(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-branch?page=${pageNo}&search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }



  createBranch(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-branch`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  exportMultipleManifests(manifestIds: number[]): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/manifest/export-multiple`, {
      manifest_ids: manifestIds
    }, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }



  exportMultipleRunwayManifests(manifestIds: number[]): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/run-manifest/export-multiple-manifests`, {
      manifest_ids: manifestIds
    }, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }


  getStatesByZone(zoneName: any): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/get-states-by-zone/${zoneName}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }




  updateBranch(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/update-branch/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteBranch(data: any): AxiosPromise<Array<any>> {
    return this.axios.delete(`${configs.context}/admin/delete-branch/${data}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  //Credit Customer
  createCreditCustomer(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-credit-customer`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllCreditCustomers(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-credit-customers?page=${pageNo}&search=${query}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  /**
   * Voucher list.
   *
   * Filters arrive as an object rather than eleven positional arguments: the old
   * signature ended in `('', '', '', '', '', '')` at every call site, and the five
   * trailing per-role statuses it carried (hod_status, general_manager_status, ...)
   * no longer exist — the configurable chain replaced them with level/approver.
   *
   * Blank values are dropped so the query string only carries real filters.
   */
  getAllExpenseVoucher(filters: Record<string, any> = {}): AxiosPromise<Array<any>> {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '' || value === false) return;
      params.append(key, String(value));
    });

    const query = params.toString();

    return this.axios.get(
      `${configs.context}/admin/voucher/get-all-vouchers${query ? `?${query}` : ''}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${store.getState().data.login.value.token}`,
          "Access-Control-Allow-Origin": "*"
        },
      }
    );
  }

  getSingleCreditCustomers(id: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-single-credit-customer/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateCreditCustomer(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/update-credit-customer/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateVoucher(data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/admin/voucher/update-voucher`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  //Audits
  // getAudits(pageNo: any, query: any): AxiosPromise<Array<any>> {
  //   return this.axios.get(`${configs.context}/admin/get-all-audits?page=${pageNo}&search=${query?.search}`, {
  //     headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
  //   });
  // }


  getAudits(pageNo: any, query: any): AxiosPromise<Array<any>> {
    const params = new URLSearchParams();
    if (pageNo) params.append('page', pageNo);
    if (query?.search) params.append('search', query.search);
    if (query?.category) params.append('category', query.category);
    if (query?.role) params.append('role', query.role);
    if (query?.date_from) params.append('date_from', query.date_from);
    if (query?.date_to) params.append('date_to', query.date_to);
    if (query?.per_page) params.append('per_page', query.per_page);

    return this.axios.get(`${configs.context}/admin/get-all-audits?${params.toString()}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  createAudit(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-audit`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateToReview(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/review-customer/${data}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  createExpenseVoucher(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/voucher/create-voucher`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getSingleExpenseVoucher(id: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/voucher/get-single-voucher/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  approveByHod(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/voucher/approve-by-hod/${data}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  rejectByHod(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/voucher/reject-by-hod/${data}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  approveByAudit(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/voucher/approve-by-audit/${data}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  rejectByAudit(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/voucher/reject-by-audit/${data}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  approveByGm(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/voucher/approve-by-gm/${data}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  rejectByGm(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/voucher/reject-by-gm/${data}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  approveBygrouphead(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/voucher/approve-by-grouphead/${data}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  rejectByGrouphead(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/voucher/reject-by-grouphead/${data}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  disburseByFinance(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/voucher/disburse-by-finance/${data}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteVoucher(data: any): AxiosPromise<Array<any>> {
    return this.axios.delete(`${configs.context}/admin/voucher/delete-voucher/${data}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateToApproved(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/approve-customer/${data}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  //Vehicle
  getAllVehicle(pageNo: any, query: any, id: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-vehicle/${id}?page=${pageNo}&search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  createVehicle(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-vehicle`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateVehicle(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/update-vehicle/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteVehicle(data: any): AxiosPromise<Array<any>> {
    return this.axios.delete(`${configs.context}/admin/delete-vehicle/${data}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getsingleUserData(id: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-single-user/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  calculateRate(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/calculate-new-rate`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  createRider(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-rider`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  createFleet(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-fleet`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  //manifest 
  createManifest(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/manifest/create-manifest`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }



  // ==================== AIRWAYBILL NUMBER METHODS ====================

  /**
   * Get all airwaybill numbers with filters
   */
  getAllAirwaybillNumbers(query: any): AxiosPromise<any> {
    const params = new URLSearchParams();
    if (query.search) params.append('search', query.search);
    if (query.status) params.append('status', query.status);
    if (query.per_page) params.append('per_page', query.per_page);

    return this.axios.get(`${configs.context}/admin/airwaybill-numbers?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /**
   * Get airwaybill numbers for dropdown (active only)
   */
  getAirwaybillNumbersDropdown(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/airwaybill-numbers/dropdown`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /**
   * Get single airwaybill number
   */
  getSingleAirwaybillNumber(id: number): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/airwaybill-numbers/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /**
   * Create new airwaybill number
   */
  createAirwaybillNumber(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/airwaybill-numbers`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /**
   * Update airwaybill number
   */
  updateAirwaybillNumber(id: number, data: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/airwaybill-numbers/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /**
   * Delete airwaybill number
   */
  deleteAirwaybillNumber(id: number): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/airwaybill-numbers/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // ENHANCED MANIFEST METHODS WITH FILTERING

  // Enhanced getAllManifest with comprehensive filtering
  getAllManifestEnhanced(query: any): AxiosPromise<Array<any>> {
    const params = new URLSearchParams();

    // Add all filter parameters
    if (query.search) params.append('search', query.search);
    if (query.start_date) params.append('start_date', query.start_date);
    if (query.end_date) params.append('end_date', query.end_date);
    if (query.sender_state) params.append('sender_state', query.sender_state);
    if (query.destination_state) params.append('destination_state', query.destination_state);
    if (query.created_by) params.append('created_by', query.created_by);
    if (query.type && query.type !== 'all') params.append('type', query.type);
    if (query.per_page) params.append('per_page', query.per_page);
    if (query.page) params.append('page', query.page);

    return this.axios.get(`${configs.context}/admin/manifest/get-all-manifest?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // Get manifests by date range
  getManifestsByDateRange(filters: any): AxiosPromise<Array<any>> {
    const params = new URLSearchParams();
    params.append('start_date', filters.start_date);
    params.append('end_date', filters.end_date);
    if (filters.per_page) params.append('per_page', filters.per_page);

    return this.axios.get(`${configs.context}/admin/manifest/filter/date-range?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // Get outbound manifests
  getOutboundManifests(filters: any): AxiosPromise<Array<any>> {
    const params = new URLSearchParams();
    params.append('sender_state', filters.sender_state);
    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    if (filters.per_page) params.append('per_page', filters.per_page);

    return this.axios.get(`${configs.context}/admin/manifest/filter/outbound?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // Get inbound manifests
  getInboundManifests(filters: any): AxiosPromise<Array<any>> {
    const params = new URLSearchParams();
    params.append('destination_state', filters.destination_state);
    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    if (filters.per_page) params.append('per_page', filters.per_page);

    return this.axios.get(`${configs.context}/admin/manifest/filter/inbound?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }


  /**
 * Download shipment upload template (Excel)
 */
  downloadShipmentTemplate(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/shipment/download-template`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob' // Important for file downloads
    });
  }

  /**
   * Download simple CSV template
   */
  downloadSimpleTemplate(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/shipment/download-simple-template`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/csv",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  // Get manifest statistics
  getManifestStats(filters: any): AxiosPromise<Array<any>> {
    const params = new URLSearchParams();
    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    if (filters.sender_state) params.append('sender_state', filters.sender_state);
    if (filters.destination_state) params.append('destination_state', filters.destination_state);
    if (filters.created_by) params.append('created_by', filters.created_by);
    if (filters.type && filters.type !== 'all') params.append('type', filters.type);

    return this.axios.get(`${configs.context}/admin/manifest/stats?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // EXISTING MANIFEST METHODS (keeping for backward compatibility)

  // Original getAllManifest method
  getAllManifest(query: any): AxiosPromise<Array<any>> {
    // Previously only `search` was forwarded, so every other filter — dates,
    // branches, type, audit_only — and pagination were silently dropped.
    // Blank values are stripped so they don't trip the backend's `nullable`
    // validation rules (e.g. `date`, `exists:users,id`).
    const allowed = [
      'search', 'start_date', 'end_date',
      'sender_state', 'destination_state',
      'sender_branch', 'destination_branch',
      'created_by', 'type', 'audit_only',
      'per_page', 'page',
    ];
    const params = new URLSearchParams();
    allowed.forEach((k) => {
      const v = query?.[k];
      if (v !== undefined && v !== null && String(v).trim() !== '') {
        params.append(k, String(v));
      }
    });

    return this.axios.get(`${configs.context}/admin/manifest/get-all-manifest?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getAllManifestByAdmin(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/manifest/get-all-manifest?page=${pageNo}&search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllManifestByOffice(outPage: any, inPage: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/manifest/get-all-manifest?out_bound_page=${outPage}&in_bound_page=${inPage}&search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getSingleManifest(id: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/manifest/get-single-manifest/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateManifest(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/manifest/update-manifest/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  //run - manifest 
  createRunManifest(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/run-manifest/create-run-manifest`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllRunManifest(pageNo: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/run-manifest/get-all-run-manifest?page=${pageNo}&search=${query?.search}&type=${query?.type}&date_from=${query?.date_from}&date_to=${query?.date_to}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }


  getDeliveryPayments(params: any): AxiosPromise<any> {
    const query = new URLSearchParams();
    if (params.search) query.append('search', params.search);
    if (params.status && params.status !== 'all') query.append('status', params.status);
    if (params.rate_type && params.rate_type !== 'all') query.append('rate_type', params.rate_type);
    if (params.start_date) query.append('start_date', params.start_date);
    if (params.end_date) query.append('end_date', params.end_date);
    if (params.rider_id) query.append('rider_id', params.rider_id);
    if (params.fleet_id) query.append('fleet_id', params.fleet_id);
    if (params.per_page) query.append('per_page', params.per_page);
    if (params.page) query.append('page', params.page);

    return this.axios.get(`${configs.context}/admin/delivery-payments?${query.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }


  getAnalyticsAirwaybillShipments(params?: any): AxiosPromise<any> {
    const query = new URLSearchParams();
    if (params?.airwaybill_number) query.append('airwaybill_number', params.airwaybill_number);
    if (params?.status) query.append('status', params.status);
    if (params?.page) query.append('page', params.page);
    if (params?.state) query.append('state', params.state);
    if (params?.fleet_name) query.append('fleet_name', params.fleet_name);
    if (params?.rider_email) query.append('rider_email', params.rider_email);
    if (params?.airwaybill_number) query.append('airwaybill_number', params.airwaybill_number);
    const qs = query.toString();
    return this.axios.get(`${configs.context}/analytics/airwaybill-shipments${qs ? '?' + qs : ''}`, {
      headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }


  getAnalyticsAttemptedDeliveryShipments(params?: any): AxiosPromise<any> {
    const query = new URLSearchParams();
    if (params?.type) query.append('type', params.type);
    if (params?.page) query.append('page', params.page);
    if (params?.date_from) query.append('date_from', params.date_from);
    if (params?.date_to) query.append('date_to', params.date_to);
    if (params?.state) query.append('state', params.state);
    if (params?.fleet_name) query.append('fleet_name', params.fleet_name);
    if (params?.rider_email) query.append('rider_email', params.rider_email);
    if (params?.airwaybill_number) query.append('airwaybill_number', params.airwaybill_number);
    const qs = query.toString();
    return this.axios.get(`${configs.context}/analytics/attempted-delivery-shipments${qs ? '?' + qs : ''}`, {
      headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  async updateFacilityFineSettings(data: { facility_base_fine_rate: number; facility_grace_period_hours: number }): Promise<any> {
    const response = await this.axios.put(`${configs.context}/admin/fine-settings/facility`, data);
    return response.data;
  }

  async toggleFacilityFineSettings(): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/fine-settings/toggle-facility`);
    return response.data;
  }


  getAnalyticsFineShipments(params?: any): AxiosPromise<any> {
    const query = new URLSearchParams();
    if (params?.type) query.append('type', params.type);
    if (params?.page) query.append('page', params.page);
    if (params?.date_from) query.append('date_from', params.date_from);
    if (params?.date_to) query.append('date_to', params.date_to);
    if (params?.state) query.append('state', params.state);
    if (params?.fleet_name) query.append('fleet_name', params.fleet_name);
    if (params?.rider_email) query.append('rider_email', params.rider_email);
    if (params?.airwaybill_number) query.append('airwaybill_number', params.airwaybill_number);

    const queryString = query.toString();
    return this.axios.get(`${configs.context}/analytics/fine-shipments${queryString ? '?' + queryString : ''}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }


  // ── Analytics Dashboard ────────────────────────────────

  getAnalyticsDashboard(params?: any): AxiosPromise<any> {
    const query = new URLSearchParams();
    if (params?.date_from) query.append('date_from', params.date_from);
    if (params?.date_to) query.append('date_to', params.date_to);
    if (params?.state) query.append('state', params.state);
    if (params?.fleet_name) query.append('fleet_name', params.fleet_name);
    if (params?.rider_email) query.append('rider_email', params.rider_email);
    if (params?.manifest_id) query.append('manifest_id', params.manifest_id);
    if (params?.airwaybill_number) query.append('airwaybill_number', params.airwaybill_number);
    if (params?.run_manifest_id) query.append('run_manifest_id', params.run_manifest_id);
    if (params?.rider_page) query.append('rider_page', params.rider_page);
    if (params?.fleet_page) query.append('fleet_page', params.fleet_page);
    if (params?.state_page) query.append('state_page', params.state_page);
    if (params?.approaching_page) query.append('approaching_page', params.approaching_page);
    if (params?.past_page) query.append('past_page', params.past_page);

    const queryString = query.toString();
    return this.axios.get(`${configs.context}/analytics/dashboard${queryString ? '?' + queryString : ''}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getAnalyticsRefresh(params?: any): AxiosPromise<any> {
    const query = new URLSearchParams();
    if (params?.date_from) query.append('date_from', params.date_from);
    if (params?.date_to) query.append('date_to', params.date_to);
    if (params?.state) query.append('state', params.state);
    if (params?.fleet_name) query.append('fleet_name', params.fleet_name);
    if (params?.rider_email) query.append('rider_email', params.rider_email);
    if (params?.manifest_id) query.append('manifest_id', params.manifest_id);
    if (params?.airwaybill_number) query.append('airwaybill_number', params.airwaybill_number);

    const queryString = query.toString();
    return this.axios.get(`${configs.context}/analytics/refresh${queryString ? '?' + queryString : ''}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getDeliveryPaymentStats(params: any): AxiosPromise<any> {
    const query = new URLSearchParams();
    if (params.start_date) query.append('start_date', params.start_date);
    if (params.end_date) query.append('end_date', params.end_date);

    return this.axios.get(`${configs.context}/admin/delivery-payments/stats?${query.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }


  getSingleRunManifest(id: any, query: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/run-manifest/get-single-run-manifest/${id}?search=${query?.search}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateRunManifest(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/run-manifest/update-run-manifest/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  //Stafs
  createStaff(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-staff`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateStaff(data: any): AxiosPromise<Array<any>> {
    return this.axios.put(`${configs.context}/admin/update-staff/${data?.id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteStaff(data: any): AxiosPromise<Array<any>> {
    return this.axios.delete(`${configs.context}/admin/delete-staff/${data}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllCountryFrom(pageNo: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-country-from?page=${pageNo}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  addCountryFrom(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-country-from`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  addCountryTo(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-country-to`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  addStateFrom(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-state-from`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  addLgaFrom(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-lga-from`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  addLgaTo(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-lga-to`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  addStateTo(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/create-state-to`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateCountryFrom(data: any, id: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/update-country-from/${id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }
  updatestateFrom(data: any, id: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/update-state-from/${id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateLgaFrom(data: any, id: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/update-lga-from/${id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateLgaTo(data: any, id: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/update-lga-to/${id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updatestateTo(data: any, id: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/update-state-to/${id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  updateCountryTo(data: any, id: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/update-country-to/${id}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteCountryFrom(id: any): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/delete-country-from/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteStateFrom(id: any): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/delete-state-from/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteLgaFrom(id: any): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/delete-lga-from/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteLgaTo(id: any): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/delete-lga-to/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteStateTo(id: any): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/delete-state-to/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  deleteCountryTo(id: any): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/delete-country-to/${id}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllCountryTo(pageNo: any): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-country-to?page=${pageNo}`, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllStateFrom(pageNo: any, data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/admin/get-state-from?page=${pageNo}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllLgaFrom(pageNo: any, data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/admin/get-lga-from?page=${pageNo}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllLgaTo(pageNo: any, data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/admin/get-lga-to?page=${pageNo}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  uploadCountryToExcel(data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/upload-excel`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  uploadImportExcel(data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/shipment/upload-shipment`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  uploadCountryToCreditCustomerExcel(data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/upload-excel-credit-customer`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  uploadLgaToExcel(data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/upload-lga-to-excel`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getPaymentPipelineStats(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/payments/pipeline-stats`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getAllPayments(query: any): AxiosPromise<any> {
    const params = new URLSearchParams();
    if (query.page) params.append('page', query.page);
    if (query.per_page) params.append('per_page', query.per_page);
    if (query.status && query.status !== 'all') params.append('status', query.status);
    if (query.rider_id) params.append('rider_id', query.rider_id);
    if (query.fleet_id) params.append('fleet_id', query.fleet_id);
    if (query.rate_type && query.rate_type !== 'all') params.append('rate_type', query.rate_type);
    if (query.delivery_city) params.append('delivery_city', query.delivery_city);
    if (query.search) params.append('search', query.search);
    if (query.date_from) params.append('date_from', query.date_from);
    if (query.date_to) params.append('date_to', query.date_to);
    if (query.week_start) params.append('week_start', query.week_start);
    if (query.payment_type && query.payment_type !== 'all') params.append('payment_type', query.payment_type);

    return this.axios.get(`${configs.context}/admin/payments/all?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // ── Payment Confirmation (Step 1) ────────────────────────

  getPendingConfirmationPayments(query: any): AxiosPromise<any> {
    const params = new URLSearchParams();
    if (query.page) params.append('page', query.page);
    if (query.per_page) params.append('per_page', query.per_page);
    if (query.rider_id) params.append('rider_id', query.rider_id);
    if (query.fleet_id) params.append('fleet_id', query.fleet_id);
    if (query.rate_type && query.rate_type !== 'all') params.append('rate_type', query.rate_type);
    if (query.delivery_city) params.append('delivery_city', query.delivery_city);
    if (query.rider_town) params.append('rider_town', query.rider_town);
    if (query.search) params.append('search', query.search);
    if (query.date_from) params.append('date_from', query.date_from);
    if (query.date_to) params.append('date_to', query.date_to);
    if (query.week_start) params.append('week_start', query.week_start);
    if (query.payment_type && query.payment_type !== 'all') params.append('payment_type', query.payment_type);
    if (query.has_fine && query.has_fine !== 'all') params.append('has_fine', query.has_fine);


    return this.axios.get(`${configs.context}/admin/payments/pending-confirmation?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  confirmPayment(id: number, data?: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/payments/${id}/confirm`, data || {}, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  bulkConfirmPayments(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/payments/bulk-confirm`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  filterConfirmPayments(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/payments/filter-confirm`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // ── Payment Approval (Step 2) ────────────────────────────

  getConfirmedPayments(query: any): AxiosPromise<any> {
    const params = new URLSearchParams();
    if (query.page) params.append('page', query.page);
    if (query.per_page) params.append('per_page', query.per_page);
    if (query.rider_id) params.append('rider_id', query.rider_id);
    if (query.fleet_id) params.append('fleet_id', query.fleet_id);
    if (query.rate_type && query.rate_type !== 'all') params.append('rate_type', query.rate_type);
    if (query.delivery_city) params.append('delivery_city', query.delivery_city);
    if (query.search) params.append('search', query.search);
    if (query.date_from) params.append('date_from', query.date_from);
    if (query.date_to) params.append('date_to', query.date_to);
    if (query.week_start) params.append('week_start', query.week_start);
    if (query.payment_type && query.payment_type !== 'all') params.append('payment_type', query.payment_type);
    if (query.has_fine && query.has_fine !== 'all') params.append('has_fine', query.has_fine);

    return this.axios.get(`${configs.context}/admin/payments/confirmed?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  approvePayment(id: number, data?: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/payments/${id}/approve`, data || {}, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  bulkApprovePayments(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/payments/bulk-approve`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  filterApprovePayments(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/payments/filter-approve`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  approvePaymentsByBalance(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/payments/approve-by-balance`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // ── Rejection ────────────────────────────────────────────

  rejectPayment(id: number, data: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/payments/${id}/reject`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  bulkRejectPayments(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/payments/bulk-reject`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // ── Fines & Deductions ───────────────────────────────────

  applyFine(userId: number, data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/payments/fine/${userId}`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  uploadLgaTCreditCustomerExcel(data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/upload-lga-to-excel-credit-customer`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }

  getAllStateTo(pageNo: any, data: any): AxiosPromise<Array<any>> {
    return this.axios.post(`${configs.context}/admin/get-state-to?page=${pageNo}`, data, {
      headers: { "Content-Type": "aplication/json", "Accept": "aplication/json", "Authorization": `Bearer ${store.getState().data.login.value.token}`, "Access-Control-Allow-Origin": "*" },
    });
  }


  // ==================== LEGACY MIGRATION ====================

  getLegacyMigrationStats(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/legacy/stats`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getUnmigratedFleets(query: any): AxiosPromise<any> {
    const params = new URLSearchParams();
    if (query.page) params.append('page', query.page);
    if (query.per_page) params.append('per_page', query.per_page);
    if (query.search) params.append('search', query.search);

    return this.axios.get(`${configs.context}/admin/legacy/unmigrated-fleets?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getUnmigratedRiders(query: any): AxiosPromise<any> {
    const params = new URLSearchParams();
    if (query.page) params.append('page', query.page);
    if (query.per_page) params.append('per_page', query.per_page);
    if (query.search) params.append('search', query.search);
    if (query.fleet_id) params.append('fleet_id', query.fleet_id);

    return this.axios.get(`${configs.context}/admin/legacy/unmigrated-riders?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  migrateFleet(userId: number, data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/legacy/migrate-fleet/${userId}`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  migrateRider(userId: number, data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/legacy/migrate-rider/${userId}`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }


  // ── Admin Wallet Management ──────────────────────────────────────────────

  /**
   * List wallets (riders + fleets). Supports search, status, and type filters.
   * Backend permission: can_view_wallets (or admin/super_admin).
   */
  async getAdminWallets(params: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/wallets`, { params });
    return response;
  }

  /**
   * Wallet dashboard summary stats.
   */
  async getAdminWalletStats(): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/wallets/stats`);
    return response;
  }

  /**
   * Export all wallets as a CSV file. Respects the same search / status /
   * type filters as getAdminWallets(). Returned as a Blob so the caller
   * can trigger a browser download.
   * Backend permission: can_view_wallets (or admin/super_admin).
   */
  async exportAdminWallets(params: any = {}): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/wallets/export`, {
      params,
      responseType: 'blob',
    });
    return response;
  }

  /**
   * Detail view: wallet + rider profile + paginated transactions.
   */
  async getAdminWalletDetail(userId: number, params?: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/wallets/${userId}`, { params });
    return response;
  }

  /**
   * Suspend or reactivate a wallet.
   * If currently active → suspend (requires `reason`).
   * If currently suspended → reactivate.
   * Backend permission: can_manage_wallets (or admin/super_admin).
   */
  async toggleAdminWalletStatus(userId: number, data?: { reason?: string }): Promise<any> {
    const response = await this.axios.put(
      `${configs.context}/admin/wallets/${userId}/toggle-status`,
      data || {}
    );
    return response;
  }

  /**
   * Clear a rider/fleet's withdrawal PIN so they can set a fresh one.
   * Also clears the failed-attempt lockout.
   * Backend permission: can_manage_wallets (or admin/super_admin).
   */
  async resetWalletPin(userId: number): Promise<any> {
    const response = await this.axios.post(
      `${configs.context}/admin/rider/${userId}/reset-pin`,
      {}
    );
    return response;
  }

  // ── Admin Withdrawals ────────────────────────────────────────────────────

  async getAdminWithdrawals(params: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/rider-withdrawals`, { params });
    return response;
  }

  // Which rail sends withdrawals (Paystack / Flutterwave), with both balances.
  // Notification channels: the WhatsApp on/off switch and the delivery and
  // cost figures behind it.
  async getNotificationChannels(): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/notification-channels`);
    return response.data;
  }

  async toggleWhatsappChannel(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/notification-channels/toggle`, data);
    return response.data;
  }

  async clearWhatsappAutoDisable(): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/notification-channels/clear-auto-disable`, {});
    return response.data;
  }

  async getPayoutProvider(): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/payout-provider`);
    return response.data;
  }

  async switchPayoutProvider(data: { provider: string; note?: string }): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/payout-provider`, data);
    return response.data;
  }

  /** One batch; call until `remaining` is 0. */
  async reverifyPayoutBanks(limit = 20, retryFailed = false): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/payout-provider/reverify-banks`, { limit, retry_failed: retryFailed });
    return response.data;
  }

  async getPayoutBankFailures(): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/payout-provider/bank-failures`);
    return response.data;
  }

  async getWithdrawalDetails(id: number): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/rider-withdrawals/${id}`);
    return response;
  }

  /** Ask the provider that sent it where the transfer stands, and settle it. */
  async syncWithdrawal(id: number): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/rider-withdrawals/${id}/sync`);
    return response;
  }

  async retryWithdrawal(id: number): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/rider-withdrawals/${id}/retry`);
    return response;
  }

  async markWithdrawalComplete(id: number, data?: { notes?: string }): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/rider-withdrawals/${id}/complete`, data || {});
    return response;
  }

  // ── Fine Settings ────────────────────────────────────────────────────────

  /**
   * Get current fine settings.
   */
  async getFineSettings(): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/fine-settings`);
    return response.data;
  }

  /**
   * Update fine settings (base rate + grace period).
   */
  async updateFineSettings(data: {
    base_fine_rate: number;
    grace_period_hours: number;
  }): Promise<any> {
    const response = await this.axios.put(`${configs.context}/admin/fine-settings`, data);
    return response.data;
  }

  /**
   * Toggle fine system on/off.
   */
  async toggleFineSettings(): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/fine-settings/toggle`);
    return response.data;
  }

  // ── Auto-attempt automation (SLA protection) ──────────────

  /**
   * Update auto-attempt threshold, fine amount and scope.
   */
  async updateAutoAttemptSettings(data: {
    auto_attempt_hours: number;
    auto_attempt_minutes: number;
    auto_attempt_fine_amount: number;
    auto_attempt_scope: string;
  }): Promise<any> {
    const response = await this.axios.put(`${configs.context}/admin/fine-settings/auto-attempt`, data);
    return response.data;
  }

  /**
   * Toggle the auto-attempt automation on/off.
   */
  async toggleAutoAttemptSettings(): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/fine-settings/toggle-auto-attempt`);
    return response.data;
  }

  // ── Auto-attempted deliveries report (read-only) ──────────

  private autoAttemptQuery(params?: any): string {
    const query = new URLSearchParams();
    const keys = [
      'search', 'rider_id', 'fleet_id', 'run_manifest_id', 'receiver_state',
      'branch', 'status', 'is_shein', 'date_from', 'date_to', 'sort',
      'page', 'per_page', 'group_by',
    ];
    keys.forEach((k) => {
      const v = params?.[k];
      if (v !== undefined && v !== null && v !== '') query.append(k, String(v));
    });
    const qs = query.toString();
    return qs ? `?${qs}` : '';
  }

  async getAutoAttemptedDeliveries(params?: any): Promise<any> {
    const response = await this.axios.get(
      `${configs.context}/admin/auto-attempted-deliveries${this.autoAttemptQuery(params)}`
    );
    return response.data;
  }

  async getAutoAttemptedStats(params?: any): Promise<any> {
    const response = await this.axios.get(
      `${configs.context}/admin/auto-attempted-deliveries/stats${this.autoAttemptQuery(params)}`
    );
    return response.data;
  }

  async getAutoAttemptedGrouped(params?: any): Promise<any> {
    const response = await this.axios.get(
      `${configs.context}/admin/auto-attempted-deliveries/grouped${this.autoAttemptQuery(params)}`
    );
    return response.data;
  }

  async getAutoAttemptedFilterOptions(): Promise<any> {
    const response = await this.axios.get(
      `${configs.context}/admin/auto-attempted-deliveries/filter-options`
    );
    return response.data;
  }

  /** CSV export — returns a Blob for client-side download. */
  async exportAutoAttemptedDeliveries(params?: any): Promise<any> {
    const response = await this.axios.get(
      `${configs.context}/admin/auto-attempted-deliveries/export${this.autoAttemptQuery(params)}`,
      { responseType: 'blob' }
    );
    return response.data;
  }


  bulkMigrateLegacy(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/legacy/bulk-migrate`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }




  // Domestic Rates
  uploadDomesticRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/rates/upload-domestic-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getPendingFinesStats(params?: any): AxiosPromise<any> {
    const query = new URLSearchParams();
    if (params?.days_range) query.append('days_range', params.days_range);
    if (params?.search) query.append('search', params.search);
    if (params?.sort) query.append('sort', params.sort);
    if (params?.page) query.append('page', params.page);
    if (params?.per_page) query.append('per_page', params.per_page);

    const queryString = query.toString();
    return this.axios.get(`${configs.context}/admin/fine-settings/pending-fines-stats${queryString ? '?' + queryString : ''}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  adminFullUpdateApplication(id: number, data: FormData): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/rider-applications/${id}/full-update`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getAllDomesticRates(): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/rates/domestic-rates`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadDomesticRateTemplate(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/rates/template/domestic`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
      },
      responseType: 'blob'
    });
  }

  // Bulk Rates
  uploadBulkRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/rates/upload-bulk-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getAllBulkRates(): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/rates/bulk-rates`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadBulkRateTemplate(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/rates/template/bulk`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
      },
      responseType: 'blob'
    });
  }

  // Bulk Extra Rates
  uploadBulkExtraRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/rates/upload-bulk-extra-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getAllBulkExtraRates(): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/rates/bulk-extra-rates`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadBulkExtraRateTemplate(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/rates/template/bulk-extra`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
      },
      responseType: 'blob'
    });
  }

  // Express Rates
  uploadExpressRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/rates/upload-express-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getAllExpressRates(): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/rates/express-rates`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadExpressRateTemplate(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/rates/template/express`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
      },
      responseType: 'blob'
    });
  }

  // Export Rates
  uploadExportRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/rates/upload-export-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getAllExportRates(): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/rates/export-rates`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadExportRateTemplate(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/rates/template/export`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
      },
      responseType: 'blob'
    });
  }



  /**
     * Export all filtered manifests without pagination limit
     * Returns all manifests matching the provided filters
     */
  exportAllFilteredManifests(filters: {
    search?: string;
    start_date?: string;
    end_date?: string;
    sender_state?: string;
    destination_state?: string;
    sender_branch?: string;
    destination_branch?: string;
    type?: string;
    created_by?: string;
  }): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/manifest/export-all-filtered`, filters, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }



  /**
 * Get branches filtered by state for cascading dropdown
 */
  getBranchesByState(state: string): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-branches-by-state/${state}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /**
   * Get unique states from branches for state dropdown
   */
  getStatesFromBranches(): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-states-from-branches`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /**
   * Get all branches as simple list for filtering
   */
  getAllBranchesSimple(): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/get-all-branches-simple`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }



  // ==================== CREDIT CUSTOMER RATE METHODS ====================

  // Fixed Rates
  uploadCreditCustomerFixedRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/credit-customer-rates/upload-fixed-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getCreditCustomerFixedRates(clientId: string): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/fixed-rates?client_id=${clientId}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // ── Standard (cash) rate cards: edit / delete / export ─────────────────
  // {type} is domestic|bulk|bulk_extra|express|export|lga_domestic|lga_bulk.

  updateStandardRateRow(type: string, id: any, data: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/rates/card/${type}/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  deleteStandardRateRow(type: string, id: any): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/rates/card/${type}/${id}`, {
      headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  deleteAllStandardRates(type: string): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/rates/card/${type}`, {
      headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  exportStandardRates(type: string): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/rates/card/${type}/export`, {
      headers: {
        "Accept": "text/csv",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  // ── Food items tariff: spreadsheet ─────────────────────────────────────

  downloadFoodRateTemplate(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/food-rates/template`, {
      headers: {
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  exportFoodRates(clientId?: string): AxiosPromise<any> {
    const qs = clientId ? `?client_id=${encodeURIComponent(clientId)}` : '';
    return this.axios.get(`${configs.context}/admin/food-rates/export${qs}`, {
      headers: {
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  uploadFoodRates(data: FormData): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/food-rates/upload`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  deleteAllFoodRates(clientId?: string): AxiosPromise<any> {
    const qs = clientId ? `?client_id=${encodeURIComponent(clientId)}` : '';
    return this.axios.delete(`${configs.context}/admin/food-rates/all${qs}`, {
      headers: {
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // ── Food items tariff ──────────────────────────────────────────────────

  /** Destinations plus what may be sent to each — drives the booking dropdowns. */
  getFoodRateOptions(clientId?: string): AxiosPromise<any> {
    const qs = clientId ? `?client_id=${encodeURIComponent(clientId)}` : '';
    return this.axios.get(`${configs.context}/admin/food-rates/options${qs}`, {
      headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getFoodRates(clientId?: string): AxiosPromise<any> {
    const qs = clientId ? `?client_id=${encodeURIComponent(clientId)}` : '';
    return this.axios.get(`${configs.context}/admin/food-rates${qs}`, {
      headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  updateFoodRate(id: any, data: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/food-rates/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  deleteFoodRate(id: any): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/food-rates/${id}`, {
      headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  saveFoodDocumentCharge(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/food-rates/document-charges`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // ── Rate card admin: edit / delete / export, for any of the five types ──
  // {type} is fixed|bulk|flat|multiplier|special.

  /** Add one band/row to a card. */
  createCreditRateRow(type: string, data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/credit-customer-rates/${type}/add`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  updateCreditRateRow(type: string, id: any, data: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/credit-customer-rates/${type}/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  deleteCreditRateRow(type: string, id: any): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/credit-customer-rates/${type}/${id}`, {
      headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  deleteAllCreditRates(type: string, clientId: string): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/credit-customer-rates/${type}?client_id=${encodeURIComponent(clientId)}`, {
      headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // ── Credit customer EXPRESS rates ──────────────────────
  //
  // Express is not zone-based and shares the same table the standard express card
  // uses, scoped to this customer. A customer with no rows of their own is priced on
  // the standard card.

  uploadCreditCustomerExpressRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/credit-customer-rates/upload-express-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getAllCreditCustomerExpressRates(clientId: string): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/express-rates?client_id=${encodeURIComponent(clientId)}`, {
      headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadCreditCustomerExpressRateTemplate(clientId?: string): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/template/express${clientId ? `?client_id=${encodeURIComponent(clientId)}` : ''}`, {
      headers: {
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  // ── Zone configuration, per credit customer ────────────────────
  //
  // Which states sit in Zone 1-4 for ONE customer. The rate cards are untouched by
  // this — they still hold four zone columns and upload the same way. A customer
  // with no configuration of their own is priced on the global zone map.

  getCreditCustomerZones(clientId: string, rateType: string): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/zones?client_id=${encodeURIComponent(clientId)}&rate_type=${encodeURIComponent(rateType)}`, {
      headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  saveCreditCustomerZones(clientId: string, rateType: string, zones: any[], states: any[]): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/credit-customer-rates/zones`, { client_id: clientId, rate_type: rateType, zones, states }, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  /** Puts the customer back on the global zone map. */
  resetCreditCustomerZones(clientId: string, rateType: string): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/credit-customer-rates/zones?client_id=${encodeURIComponent(clientId)}&rate_type=${encodeURIComponent(rateType)}`, {
      headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // Streamed CSV of the rates as they stand — the same columns the upload parser
  // expects, so the file can be edited and uploaded straight back.
  exportCreditRates(type: string, clientId: string): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/${type}/export?client_id=${encodeURIComponent(clientId)}`, {
      headers: {
        "Accept": "text/csv",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  downloadCreditCustomerFixedRateTemplate(clientId?: string): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/template/fixed${clientId ? `?client_id=${encodeURIComponent(clientId)}` : ''}`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  // Bulk Rates
  uploadCreditCustomerBulkRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/credit-customer-rates/upload-bulk-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getCreditCustomerBulkRates(clientId: string): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/bulk-rates?client_id=${clientId}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadCreditCustomerBulkRateTemplate(clientId?: string): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/template/bulk${clientId ? `?client_id=${encodeURIComponent(clientId)}` : ''}`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  // Flat Rates
  uploadCreditCustomerFlatRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/credit-customer-rates/upload-flat-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getCreditCustomerFlatRates(clientId: string): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/flat-rates?client_id=${clientId}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadCreditCustomerFlatRateTemplate(clientId?: string): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/template/flat${clientId ? `?client_id=${encodeURIComponent(clientId)}` : ''}`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  // Multiplier Rates
  uploadCreditCustomerMultiplierRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/credit-customer-rates/upload-multiplier-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getCreditCustomerMultiplierRates(clientId: string): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/multiplier-rates?client_id=${clientId}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadCreditCustomerMultiplierRateTemplate(clientId?: string): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/template/multiplier${clientId ? `?client_id=${encodeURIComponent(clientId)}` : ''}`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  // Special Rates
  uploadCreditCustomerSpecialRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/credit-customer-rates/upload-special-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getCreditCustomerSpecialRates(clientId: string): AxiosPromise<Array<any>> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/special-rates?client_id=${clientId}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadCreditCustomerSpecialRateTemplate(clientId?: string): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/credit-customer-rates/template/special${clientId ? `?client_id=${encodeURIComponent(clientId)}` : ''}`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  // Calculate Credit Customer Rate
  calculateCreditCustomerRate(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/credit-customer-rates/calculate-rate`, data, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }


  // LGA Domestic Rates
  uploadLgaDomesticRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/lga-rates/upload-domestic-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getLgaDomesticRates(stateName: string = ''): AxiosPromise<any> {
    const params = stateName ? `?state_name=${stateName}` : '';
    return this.axios.get(`${configs.context}/admin/lga-rates/domestic-rates${params}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadLgaDomesticRateTemplate(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/lga-rates/template/domestic`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  // LGA Bulk Rates
  uploadLgaBulkRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/lga-rates/upload-bulk-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getLgaBulkRates(stateName: string = ''): AxiosPromise<any> {
    const params = stateName ? `?state_name=${stateName}` : '';
    return this.axios.get(`${configs.context}/admin/lga-rates/bulk-rates${params}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  downloadLgaBulkRateTemplate(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/lga-rates/template/bulk`, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
      responseType: 'blob'
    });
  }

  // Credit Customer LGA Domestic Rates
  uploadCreditCustomerLgaDomesticRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/lga-rates/upload-domestic-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getCreditCustomerLgaDomesticRates(clientId: string, stateName: string = ''): AxiosPromise<any> {
    const params = new URLSearchParams();
    params.append('client_id', clientId);
    if (stateName) params.append('state_name', stateName);

    return this.axios.get(`${configs.context}/admin/lga-rates/domestic-rates?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // Credit Customer LGA Bulk Rates
  uploadCreditCustomerLgaBulkRates(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/lga-rates/upload-bulk-rates`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getCreditCustomerLgaBulkRates(clientId: string, stateName: string = ''): AxiosPromise<any> {
    const params = new URLSearchParams();
    params.append('client_id', clientId);
    if (stateName) params.append('state_name', stateName);

    return this.axios.get(`${configs.context}/admin/lga-rates/bulk-rates?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }


  /**
 * Get LGAs by state with rate information
 */
  getLgasByState(stateName: string, serviceType: string = 'domestic', clientId: string = ''): AxiosPromise<any> {
    const params = new URLSearchParams();
    params.append('state_name', stateName);
    params.append('service_type', serviceType);
    if (clientId) params.append('client_id', clientId);

    return this.axios.get(`${configs.context}/admin/lga-rates/lgas-by-state?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // ── Rider Loans ────────────────────────────────────────────
  private loanHeaders() {
    return {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${store.getState().data.login.value.token}`,
      "Access-Control-Allow-Origin": "*"
    };
  }

  /** Accounts a loan can be recorded against — those with a wallet money reaches. */
  getEligibleLoanRiders(search: string): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/rider-loans/eligible-riders?search=${encodeURIComponent(search)}`, { headers: this.loanHeaders() });
  }

  getLoanCleanupReview(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/rider-loans/cleanup/review`, { headers: this.loanHeaders() });
  }

  /** The clean-up report as an .xlsx blob — summary, changes made, still to fix. */
  downloadLoanCleanupReport(): AxiosPromise<Blob> {
    return this.axios.get(`${configs.context}/admin/rider-loans/cleanup/report`, { headers: this.loanHeaders(), responseType: 'blob' });
  }

  applyLoanCleanup(moves: any[]): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/rider-loans/cleanup/apply`, { moves }, { headers: this.loanHeaders() });
  }

  getRiderLoans(params: any = {}): AxiosPromise<any> {
    const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''));
    const qs = new URLSearchParams(clean as any).toString();
    return this.axios.get(`${configs.context}/admin/rider-loans?${qs}`, { headers: this.loanHeaders() });
  }

  recordRiderLoan(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/rider-loans`, data, { headers: this.loanHeaders() });
  }

  getRiderLoanDetail(id: number): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/rider-loans/${id}`, { headers: this.loanHeaders() });
  }

  updateRiderLoan(id: number, data: any): AxiosPromise<any> {
    return this.axios.put(`${configs.context}/admin/rider-loans/${id}`, data, { headers: this.loanHeaders() });
  }

  cancelRiderLoan(id: number): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/rider-loans/${id}/cancel`, {}, { headers: this.loanHeaders() });
  }

  getLoanWalletOverview(params: any = {}): AxiosPromise<any> {
    const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''));
    const qs = new URLSearchParams(clean as any).toString();
    return this.axios.get(`${configs.context}/admin/rider-loans/wallet/overview?${qs}`, { headers: this.loanHeaders() });
  }

  // Loan wallet: saved company payout accounts + withdrawal history.
  getLoanWalletBankAccounts(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/admin/rider-loans/wallet/bank-accounts`, { headers: this.loanHeaders() });
  }

  saveLoanWalletBankAccount(data: any, id?: number): AxiosPromise<any> {
    return id
      ? this.axios.put(`${configs.context}/admin/rider-loans/wallet/bank-accounts/${id}`, data, { headers: this.loanHeaders() })
      : this.axios.post(`${configs.context}/admin/rider-loans/wallet/bank-accounts`, data, { headers: this.loanHeaders() });
  }

  deleteLoanWalletBankAccount(id: number): AxiosPromise<any> {
    return this.axios.delete(`${configs.context}/admin/rider-loans/wallet/bank-accounts/${id}`, { headers: this.loanHeaders() });
  }

  getLoanWalletWithdrawals(params: any = {}): AxiosPromise<any> {
    const qs = new URLSearchParams(params).toString();
    return this.axios.get(`${configs.context}/admin/rider-loans/wallet/withdrawals?${qs}`, { headers: this.loanHeaders() });
  }

  /** The accounts behind the "rider negative exposure" total. Read-only. */
  getLoanWalletNegativeExposure(params: any = {}): AxiosPromise<any> {
    const qs = new URLSearchParams(params).toString();
    return this.axios.get(`${configs.context}/admin/rider-loans/wallet/negative-exposure?${qs}`, { headers: this.loanHeaders() });
  }

  loanWalletWithdraw(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/rider-loans/wallet/withdraw`, data, { headers: this.loanHeaders() });
  }

  // ── Bulk Delivery Photos ───────────────────────────────────
  uploadDeliveryPhoto(data: FormData): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/shipment/upload-delivery-photo`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  getAwaitingDeliveryPhotos(params: any = {}): AxiosPromise<any> {
    const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''));
    const qs = new URLSearchParams(clean as any).toString();
    return this.axios.get(`${configs.context}/shipment/awaiting-delivery-photos?${qs}`, { headers: this.loanHeaders() });
  }

  lookupShipmentsForPod(shipmentNumbers: string[]): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/shipment/lookup-shipments-for-pod`, { shipment_numbers: shipmentNumbers }, { headers: this.loanHeaders() });
  }

  getAwaitingDeliveryPhotoFilters(): AxiosPromise<any> {
    return this.axios.get(`${configs.context}/shipment/awaiting-delivery-photo-filters`, { headers: this.loanHeaders() });
  }

  bulkApplyDeliveryPhoto(data: FormData): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/shipment/bulk-apply-delivery-photo`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*"
      },
    });
  }

  // ── Custom Duty Payments ───────────────────────────────────
  customDutyParse(data: FormData): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/custom-duty/parse`, data, {
      headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${store.getState().data.login.value.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    });
  }

  customDutyProcessBatch(data: any): AxiosPromise<any> {
    return this.axios.post(`${configs.context}/admin/custom-duty/process-batch`, data, { headers: this.loanHeaders() });
  }

  getCustomDutyList(params: any = {}): AxiosPromise<any> {
    const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''));
    const qs = new URLSearchParams(clean as any).toString();
    return this.axios.get(`${configs.context}/admin/custom-duty?${qs}`, { headers: this.loanHeaders() });
  }

  async exportCustomDuty(params: any = {}): Promise<any> {
    const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''));
    return this.axios.get(`${configs.context}/admin/custom-duty/export`, {
      params: clean,
      responseType: 'blob',
      headers: this.loanHeaders(),
    });
  }

  // ==================== CORPORATE CLIENT BILLING ====================
  // Newer convention: constructed per call (so the constructor picks up the current
  // token) and returns response.data already unwrapped — callers read .success/.data.

  async getBillingClients(): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/billing/clients`);
    return response.data;
  }

  async createBillingClient(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/clients`, data);
    return response.data;
  }

  async deleteBillingClient(id: any): Promise<any> {
    const response = await this.axios.delete(`${configs.context}/admin/billing/clients/${id}`);
    return response.data;
  }

  async updateBillingClient(id: any, data: any): Promise<any> {
    const response = await this.axios.put(`${configs.context}/admin/billing/clients/${id}`, data);
    return response.data;
  }

  async getBillingStates(): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/billing/states`);
    return response.data;
  }

  async getBillingConfiguration(clientId: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/billing/clients/${clientId}/configuration`);
    return response.data;
  }

  async getFfdxRunShipments(id: any, params: any = {}): Promise<any> {
    const q = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== '' && v !== null && v !== undefined) as any
    ).toString();
    const response = await this.axios.get(`${configs.context}/admin/ffdx-feed/${id}/shipments${q ? `?${q}` : ''}`);
    return response.data;
  }

  async reparseFfdxRun(id: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/ffdx-feed/${id}/reparse`, {});
    return response.data;
  }

  async downloadFfdxPayload(id: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/ffdx-feed/${id}/payload`, {
      responseType: 'blob',
    });
    return response.data;
  }

  async getFfdxFeedRuns(params: any = {}): Promise<any> {
    const q = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== '' && v !== null && v !== undefined) as any
    ).toString();
    const response = await this.axios.get(`${configs.context}/admin/ffdx-feed${q ? `?${q}` : ''}`);
    return response.data;
  }

  async getFfdxFeedStats(): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/ffdx-feed/stats`);
    return response.data;
  }

  async getFfdxFeedRun(id: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/ffdx-feed/${id}`);
    return response.data;
  }

  async runFfdxFeed(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/ffdx-feed/run`, data);
    return response.data;
  }

  async fixUnmappedStates(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/fix-states`, data);
    return response.data;
  }

  async getNoDocketShipments(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/no-docket`, data);
    return response.data;
  }

  /** The individual shipments behind one unrecognised destination state. */
  async getUnmappedStateShipments(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/unmapped-shipments`, data);
    return response.data;
  }

  async deleteClientInvoice(id: any): Promise<any> {
    const response = await this.axios.delete(`${configs.context}/admin/billing/invoices/${id}`);
    return response.data;
  }

  async getReturnRate(clientId: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/billing/clients/${clientId}/return-rate`);
    return response.data;
  }

  async saveReturnRate(clientId: any, data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/clients/${clientId}/return-rate`, data);
    return response.data;
  }

  /** Prices an uploaded return sheet without writing anything. */
  async previewReturnInvoice(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/return/preview`, data);
    return response.data;
  }

  async generateReturnInvoice(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/return/generate`, data);
    return response.data;
  }

  async getInvoiceCompanies(): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/billing/companies`);
    return response.data;
  }

  /** Multipart because the logo is a file; Laravel needs POST for updates too. */
  async saveInvoiceCompany(id: any, data: any, logo: File | null): Promise<any> {
    const form = new FormData();
    Object.entries(data).forEach(([k, v]) => form.append(k, v === null || v === undefined ? '' : String(v)));
    if (logo) form.append('logo', logo);

    const url = id
      ? `${configs.context}/admin/billing/companies/${id}`
      : `${configs.context}/admin/billing/companies`;

    const response = await this.axios.post(url, form, { headers: { 'Content-Type': 'multipart/form-data' } });
    return response.data;
  }

  async deleteInvoiceCompany(id: any): Promise<any> {
    const response = await this.axios.delete(`${configs.context}/admin/billing/companies/${id}`);
    return response.data;
  }

  async getBillingDockets(clientId: any, search: string = '', clientIds: any[] = []): Promise<any> {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    // Dockets across every client being billed, so a docket is pickable whichever
    // client it belongs to.
    if (clientIds.length > 1) params.set('client_ids', clientIds.join(','));
    const q = params.toString() ? `?${params.toString()}` : '';
    const response = await this.axios.get(`${configs.context}/admin/billing/clients/${clientId}/dockets${q}`);
    return response.data;
  }

  async createBillingZone(clientId: any, data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/clients/${clientId}/zones`, data);
    return response.data;
  }

  async updateBillingZone(zoneId: any, data: any): Promise<any> {
    const response = await this.axios.put(`${configs.context}/admin/billing/zones/${zoneId}`, data);
    return response.data;
  }

  async deleteBillingZone(zoneId: any): Promise<any> {
    const response = await this.axios.delete(`${configs.context}/admin/billing/zones/${zoneId}`);
    return response.data;
  }

  async setBillingZoneStates(zoneId: any, states: string[]): Promise<any> {
    const response = await this.axios.put(`${configs.context}/admin/billing/zones/${zoneId}/states`, { states });
    return response.data;
  }

  // ── Docket-level charges (clearance and the like) ──────────────────────
  // Hang off the client, not off a zone: a docket carries shipments bound for
  // every zone, so a docket-level charge can never belong to one of them.

  async createBillingCharge(clientId: any, data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/clients/${clientId}/charges`, data);
    return response.data;
  }

  async updateBillingCharge(chargeId: any, data: any): Promise<any> {
    const response = await this.axios.put(`${configs.context}/admin/billing/charges/${chargeId}`, data);
    return response.data;
  }

  async deleteBillingCharge(chargeId: any): Promise<any> {
    const response = await this.axios.delete(`${configs.context}/admin/billing/charges/${chargeId}`);
    return response.data;
  }

  // ── Temporary support passwords ────────────────────────────────────────────

  getTemporaryPasswordHistory(userId: any): Promise<any> {
    return this.axios.get(`${configs.context}/admin/temporary-password/${userId}`).then((r: any) => r.data);
  }

  generateTemporaryPassword(userId: any, data: any): Promise<any> {
    return this.axios.post(`${configs.context}/admin/temporary-password/${userId}`, data).then((r: any) => r.data);
  }

  revokeTemporaryPassword(userId: any): Promise<any> {
    return this.axios.delete(`${configs.context}/admin/temporary-password/${userId}`).then((r: any) => r.data);
  }

  // ── Bank-transfer payment proofs (cash customers) ──────────────────────────

  // ── Unpaid shipments by sender + pay with transfer ──────────

  async getUnpaidSenders(search = ''): Promise<any> {
    const qs = search ? `?search=${encodeURIComponent(search)}` : '';
    const response = await this.axios.get(`${configs.context}/admin/payment-proofs/unpaid-senders${qs}`);
    return response.data;
  }

  async getUnpaidShipments(senderKey: string): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/payment-proofs/unpaid-shipments?sender=${encodeURIComponent(senderKey)}`);
    return response.data;
  }

  async listTransferRequests(params: any = {}): Promise<any> {
    const qs = new URLSearchParams(params).toString();
    const response = await this.axios.get(`${configs.context}/admin/payment-proofs/transfer-requests${qs ? `?${qs}` : ''}`);
    return response.data;
  }

  /** Asks Paystack for a bank account the customer can transfer into right now. */
  async createTransferRequest(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/payment-proofs/transfer-requests`, data);
    return response.data;
  }

  async getTransferRequest(id: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/payment-proofs/transfer-requests/${id}`);
    return response.data;
  }

  /** Pulls the status from Paystack directly, for when the webhook is slow. */
  async verifyTransferRequest(id: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/payment-proofs/transfer-requests/${id}/verify`);
    return response.data;
  }

  /** Withdraws an open account so its shipments can be paid another way. */
  async cancelTransferRequest(id: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/payment-proofs/transfer-requests/${id}/cancel`);
    return response.data;
  }

  async listPaymentProofs(params: any = {}): Promise<any> {
    const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''));
    const qs = new URLSearchParams(clean as any).toString();
    const response = await this.axios.get(`${configs.context}/admin/payment-proofs${qs ? `?${qs}` : ''}`);
    return response.data;
  }

  async getPaymentProof(id: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/payment-proofs/${id}`);
    return response.data;
  }

  /** Multipart: the proof image plus the shipments it covers. */
  async submitPaymentProof(form: FormData): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/payment-proofs`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  async confirmPaymentProof(id: any, data: any = {}): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/payment-proofs/${id}/confirm`, data);
    return response.data;
  }

  async rejectPaymentProof(id: any, data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/payment-proofs/${id}/reject`, data);
    return response.data;
  }

  async previewClientInvoice(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/preview`, data);
    return response.data;
  }

  /**
   * Streamed preview. Reports progress while the server prices, so a period with
   * tens of thousands of shipments shows a moving count instead of a spinner that
   * cannot be told apart from a hang.
   *
   * Uses fetch rather than the shared axios instance because axios is XHR-based here
   * and buffers the whole body before resolving, which would defeat the point. The
   * server sends newline-delimited JSON: a `start`, a `progress` per 500 shipments,
   * then one `done` carrying exactly the payload the non-streaming preview returns.
   */
  async previewClientInvoiceStream(
    data: any,
    onProgress?: (processed: number, total: number) => void,
    signal?: AbortSignal,
  ): Promise<any> {
    const res = await fetch(`${configs.context}/admin/billing/invoices/preview-stream`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/x-ndjson',
        Authorization: `Bearer ${store.getState().data.login.value.token}`,
      },
      body: JSON.stringify(data),
      signal,
    });

    if (!res.ok) {
      // Validation failures still come back as ordinary JSON with a status code.
      let message = `Preview failed (${res.status})`;
      try {
        const body = await res.json();
        message = body?.message || body?.errors?.[Object.keys(body.errors || {})[0]]?.[0] || message;
      } catch { /* body was not JSON */ }
      throw new Error(message);
    }

    if (!res.body) throw new Error('Streaming is not supported by this browser');

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let done: any = null;
    // Tracked so a stream that dies mid-flight can say how far it got. "Stopped after
    // 34,500 of 100,000" points straight at the period being too large; a bare
    // "ended before it finished" leaves the operator guessing.
    let seen = 0;
    let expected = 0;

    // Parse line by line; a chunk boundary can land mid-line, so whatever follows
    // the last newline stays in the buffer until the next read completes it.
    for (;;) {
      const { value, done: finished } = await reader.read();
      if (finished) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() ?? '';

      for (const line of lines) {
        if (!line.trim()) continue;

        let evt: any;
        try { evt = JSON.parse(line); } catch { continue; }

        if (evt.type === 'progress') { seen = evt.processed; expected = evt.total; onProgress?.(evt.processed, evt.total); }
        else if (evt.type === 'start') { expected = evt.total; onProgress?.(0, evt.total); }
        else if (evt.type === 'done') done = evt.data;
        else if (evt.type === 'error') throw new Error(evt.message || 'Preview failed');
      }
    }

    // The connection can drop mid-stream and still look like a clean finish, so a
    // missing `done` is treated as a failure rather than an empty preview.
    if (!done) {
      throw new Error(
        expected > 0
          ? `Preview stopped after pricing ${seen.toLocaleString()} of ${expected.toLocaleString()} shipments. `
            + 'The period is too large for one run — try a shorter date range, or bill one docket at a time.'
          : 'Preview ended before it finished. Please try again.',
      );
    }

    return { success: true, data: done };
  }

  /**
   * Generation, streamed with progress.
   *
   * Same shape as previewClientInvoiceStream and for the same reason: a two-month
   * period takes long enough that a silent request is indistinguishable from a hung
   * one, and any proxy in front of it may give up on an idle connection. Emitting
   * progress keeps bytes moving and gives the operator a real count.
   */
  async generateClientInvoiceStream(
    data: any,
    onProgress?: (processed: number, total: number) => void,
    signal?: AbortSignal,
  ): Promise<any> {
    const res = await fetch(`${configs.context}/admin/billing/invoices/generate-stream`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/x-ndjson',
        Authorization: `Bearer ${store.getState().data.login.value.token}`,
      },
      body: JSON.stringify(data),
      signal,
    });

    if (!res.ok) {
      let message = `Could not generate invoice (${res.status})`;
      try {
        const body = await res.json();
        message = body?.message || body?.errors?.[Object.keys(body.errors || {})[0]]?.[0] || message;
      } catch { /* body was not JSON */ }
      throw new Error(message);
    }

    if (!res.body) throw new Error('Streaming is not supported by this browser');

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let finishedEvt: any = null;
    let seen = 0;
    let expected = 0;

    for (;;) {
      const { value, done: finished } = await reader.read();
      if (finished) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() ?? '';

      for (const line of lines) {
        if (!line.trim()) continue;

        let evt: any;
        try { evt = JSON.parse(line); } catch { continue; }

        if (evt.type === 'progress') { seen = evt.processed; expected = evt.total; onProgress?.(evt.processed, evt.total); }
        else if (evt.type === 'start') { expected = evt.total; onProgress?.(0, evt.total); }
        else if (evt.type === 'done') finishedEvt = { success: true, message: evt.message, data: evt.data };
        // A refusal is a decision, not a failure: nothing was written and the reason
        // belongs on screen rather than in an exception.
        else if (evt.type === 'refused') finishedEvt = { success: false, message: evt.message, data: evt.data };
        else if (evt.type === 'error') throw new Error(evt.message || 'Could not generate invoice');
      }
    }

    // The connection can drop mid-stream and still look like a clean finish. The
    // server rolls its transaction back in that case, so nothing was billed — but the
    // caller must not be told it succeeded.
    if (!finishedEvt) {
      throw new Error(
        (expected > 0
          ? `Generation stopped after ${seen.toLocaleString()} of ${expected.toLocaleString()} shipments. `
          : 'Generation ended before it finished. ')
        + 'Nothing was saved — the whole invoice is written in one transaction, so a run that '
        + 'does not finish leaves no trace. Try a shorter date range, or bill one docket at a time.',
      );
    }

    return finishedEvt;
  }

  // ── Batched preview / generate ────────────────────────────────────────
  // A whole period cannot be done in one request: the platform closes the
  // connection at roughly thirty seconds regardless of PHP's own timer, which is
  // what truncated the streamed preview at ~30,000 of 53,636 shipments. These
  // endpoints do a bounded window each, and the caller loops.

  async previewClientInvoiceBatch(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/preview-batch`, data);
    return response.data;
  }

  async previewClientInvoiceFinalise(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/preview-finalise`, data);
    return response.data;
  }

  async generateClientInvoiceStart(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/generate-start`, data);
    return response.data;
  }

  async generateClientInvoiceBatch(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/generate-batch`, data);
    return response.data;
  }

  async generateClientInvoiceFinalise(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/generate-finalise`, data);
    return response.data;
  }

  // Saved docket weights. Not draft invoices — a draft invoice claims its shipments,
  // a saved sheet claims nothing and creates no invoice.

  async listInvoiceWeightSheets(params: any = {}): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/billing/weight-sheets`, { params });
    return response.data;
  }

  async saveInvoiceWeightSheet(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/weight-sheets`, data);
    return response.data;
  }

  /** POST, not GET: the dockets currently on screen are sent so the server can say
   *  which saved weights will actually land. */
  async loadInvoiceWeightSheet(id: any, data: any = {}): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/weight-sheets/${id}`, data);
    return response.data;
  }

  async deleteInvoiceWeightSheet(id: any): Promise<any> {
    const response = await this.axios.delete(`${configs.context}/admin/billing/weight-sheets/${id}`);
    return response.data;
  }

  async discardDraftInvoice(id: any): Promise<any> {
    const response = await this.axios.delete(`${configs.context}/admin/billing/invoices/${id}/draft`);
    return response.data;
  }

  async generateClientInvoice(data: any): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/generate`, data);
    return response.data;
  }

  async getClientInvoices(params: any = {}): Promise<any> {
    const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''));
    const qs = new URLSearchParams(clean as any).toString();
    const response = await this.axios.get(`${configs.context}/admin/billing/invoices${qs ? `?${qs}` : ''}`);
    return response.data;
  }

  async getClientInvoice(id: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/billing/invoices/${id}`);
    return response.data;
  }

  async updateClientInvoiceStatus(id: any, data: any): Promise<any> {
    const response = await this.axios.put(`${configs.context}/admin/billing/invoices/${id}/status`, data);
    return response.data;
  }

  async voidClientInvoice(id: any, data: any = {}): Promise<any> {
    const response = await this.axios.post(`${configs.context}/admin/billing/invoices/${id}/void`, data);
    return response.data;
  }

  /** xlsx blob for client-side download. */
  async exportClientInvoice(id: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/billing/invoices/${id}/export`, {
      responseType: 'blob',
    });
    return response.data;
  }

  /** pdf blob for client-side download. */
  async downloadClientInvoicePdf(id: any): Promise<any> {
    const response = await this.axios.get(`${configs.context}/admin/billing/invoices/${id}/pdf`, {
      responseType: 'blob',
    });
    return response.data;
  }

}